//import i18n from '@/_helpers/lang';
import { extend } from "vee-validate";
import { required, is_not, email, digits, regex, numeric, min_value, max_value } from "vee-validate/dist/rules";

extend('required', required);
extend('is_not', is_not);
extend('numeric', numeric);
extend('min_value', min_value);
extend('max_value', max_value);
extend('email', email);
extend('digits', digits);
extend('regex', regex);


export const rules = {
    nif: {
        regex: /^([0-9]{8}[a-zA-Z])/,
        required: true
    },
    numericField: {
        numeric: true,
    },
    telephone: {
        digits: 9
    },
    requiredField: {
        required: true
    },
    perDiscapacidad: {
        max_value: 100,
        min_value: 0
    },
    importe: {
        regex: /^[0-9]+(,[0-9]{1,2})?$/
    }
};